import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import {
  Stack,
  Paper,
  Button,
  PaperProps,
  ButtonProps,
  MobileStepper,
} from "@mui/material";

import { PADDING } from "styles";

const StepperButton = ({
  actionVariant,
  ...props
}: ButtonProps & { actionVariant: "increase" | "reduce" }) => {
  return (
    <Button size="small" {...props}>
      {actionVariant === "increase" ? (
        <>
          Next
          <KeyboardArrowRight />
        </>
      ) : (
        <>
          <KeyboardArrowLeft />
          Back
        </>
      )}
    </Button>
  );
};

export const StepperContainer = ({
  steps,
  style,
  children,
  activeStep,
  onChangeStep,
  containerFlex,
  ...paperProps
}: React.PropsWithChildren<
  {
    steps?: number;
    activeStep?: number;
    containerFlex?: number | string;
    onChangeStep?: (value: number) => void;
  } & PaperProps
>) => {
  const handleStepButtonClick = (variant: "increase" | "reduce") => () => {
    if (onChangeStep) {
      const currentStep = activeStep ?? 0;
      onChangeStep(variant === "increase" ? currentStep + 1 : currentStep - 1);
    }
  };

  return (
    <Paper
      elevation={2}
      variant="elevation"
      style={{
        display: "flex",
        flexDirection: "column",
        padding: PADDING.default,
        ...style,
      }}
      {...paperProps}
    >
      <Stack flex={containerFlex} direction="column">
        {children}
      </Stack>

      {steps && steps > 0 && (
        <MobileStepper
          steps={steps}
          variant="text"
          position="static"
          activeStep={activeStep}
          sx={{
            flexDirection: "row",
            gap: PADDING.default,
            justifyContent: "center",
            marginTop: PADDING.default,
          }}
          nextButton={
            <StepperButton
              actionVariant="increase"
              disabled={activeStep === steps - 1}
              onClick={handleStepButtonClick("increase")}
            />
          }
          backButton={
            <StepperButton
              actionVariant="reduce"
              disabled={activeStep === 0}
              onClick={handleStepButtonClick("reduce")}
            />
          }
        />
      )}
    </Paper>
  );
};
